import { TextMediaLtr } from "../../../../modules/text-media/components/TextMediaLtr/TextMediaLtr";
import { TextMediaRtl } from "../../../../modules/text-media/components/TextMediaRtl/TextMediaRtl";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = (props: ITextMediaBlockProps) => {
  if (!props.image && !props.video) {
    return null;
  }

  if (props.direction === "ltr") {
    return <TextMediaLtr {...props} />;
  }

  return <TextMediaRtl {...props} />;
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
